export default __webpack_public_path__ + "static/media/Snd_Try0.b88d3a67.mp3";